import { render, staticRenderFns } from "./productTab.vue?vue&type=template&id=7582f081&scoped=true"
import script from "./productTab.vue?vue&type=script&lang=js"
export * from "./productTab.vue?vue&type=script&lang=js"
import style0 from "./productTab.vue?vue&type=style&index=0&id=7582f081&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7582f081",
  null
  
)

export default component.exports